export default __webpack_public_path__ + "static/media/logoWhite.15b81d27.svg";